import React from 'react';
import PropTypes from 'prop-types';
import PricingChooser from '../../common/components/PricingChooser';
import { getQualitiesDataForLicensesFromGalleryPricing, qualityDataToString } from '../../../common/QualityImageData';
import s from './cartListItem.scss';
import cx from 'classnames';
import cartItemsStatuses from 'wix-art-store-3rd-party/dist/src/sdk/cartItemsStatuses';

function generatePricingValue(licenseId, qualityId) {
  return `${licenseId};${qualityId}`;
}

function ItemDesktopLayout(props) {
  const { pricingChooser, title, details, imageUrl, t, isValid } = props;
  return (
    <div className={s.itemContainer}>
      <img className={s.previewImage} src={imageUrl} style={{ maxWidth: '100%' }}/>
      <div className={s.itemDetailsContent}>
        {!isValid && (
          <div className={cx(s.itemTitle, s.itemError)}>
            <span>{t('Wix_Provider_Cart_Items_Invalid_Item')}</span>
          </div>
        )}
        <div className={s.itemTitle}>{title}</div>
        <div className={s.itemDetails}>{details}</div>
        <div className={s.pricingChooserContainer}>
          {pricingChooser}
          {!isValid && <div className={cx('shop-background', s.disabledBox)}/>}
        </div>
      </div>
    </div>
  );
}

ItemDesktopLayout.propTypes = {
  pricingChooser: PropTypes.object,
  title: PropTypes.string,
  details: PropTypes.string,
  imageUrl: PropTypes.string,
  t: PropTypes.func,
  isValid: PropTypes.bool
};

function ItemMobileLayout(props) {
  const { pricingChooser, title, details, imageUrl, t, isValid } = props;
  return (
    <div className={s.itemContainerM}>
      <div className={s.detailsContainerM}>
        <img className={s.previewImageM} src={imageUrl} style={{ maxWidth: '100%' }}/>
        <div className={s.itemDetailsContentM}>
          {!isValid && (
            <div className={cx(s.itemTitleM, s.itemErrorM)}>
              <span>{t('Wix_Provider_Cart_Items_Invalid_Item')}</span>
            </div>
          )}
          <div className={s.itemTitleM}>{title}</div>
          <div className={s.itemDetailsM}>{details}</div>
        </div>
      </div>

      <div className={s.pricingChooserContainerM}>
        {pricingChooser}
        {!isValid && <div className={cx('shop-background', s.disabledBox)}/>}
      </div>
    </div>
  );
}

ItemMobileLayout.propTypes = {
  pricingChooser: PropTypes.object,
  title: PropTypes.string,
  details: PropTypes.string,
  imageUrl: PropTypes.string,
  t: PropTypes.func,
  isValid: PropTypes.bool
};

export function CartListItem(props) {
  const { item, galleryPricings, onItemPurchaseAttributesChanged, onRemoveItem, site, t, deviceType } = props;

  const { licenses, imageQualities, localeInfo } = site;
  const { selectedLicenseId, selectedQualityId, itemWidth, itemHeight, imageUrl, status } = item;
  const isValid = status !== cartItemsStatuses.INVALID;
  let currentImagePricingData = null;
  const selectedValue = generatePricingValue(selectedLicenseId, selectedQualityId);

  getQualitiesDataForLicensesFromGalleryPricing({
    itemWidth,
    itemHeight,
    imageQualities,
    licenses,
    galleryPricing: galleryPricings,
    callback: (licenseId, arrSupportedQualitiesData) => {
      const license = licenses.find(licenseInfo => licenseInfo.licenseId === licenseId);
      arrSupportedQualitiesData.forEach(data => {
        const { qualityData, quality } = data;
        const qualityId = quality.qualityId;
        const currentValue = generatePricingValue(license.licenseId, qualityId);
        if (currentValue === selectedValue) {
          currentImagePricingData = qualityDataToString(qualityData);
        }
      });
    }
  });

  const Layout = deviceType === 'mobile' ? ItemMobileLayout : ItemDesktopLayout;

  return (
    <div className={s.container}>
      <Layout
        pricingChooser={
          <PricingChooser
            onPricingChanged={(licenseId, qualityId) => onItemPurchaseAttributesChanged(item, { licenseId, qualityId })}
            localeInfo={localeInfo}
            imageQualities={imageQualities}
            galleryPricings={galleryPricings}
            licenses={licenses}
            selectedLicenseId={selectedLicenseId}
            selectedQualityId={selectedQualityId}
            itemWidth={itemWidth}
            itemHeight={itemHeight}
            t={t}
          />
        }
        isValid={isValid}
        t={t}
        title={item.title}
        details={currentImagePricingData}
        imageUrl={imageUrl}
      />
      <button
        aria-label={'Remove item from cart'}
        className={cx(s.removeButton, { [s.removeError]: !isValid }, 'shop-description')}
        onClick={() => onRemoveItem(item)}
      >
        <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.965.686L8.328.053l-3.8 3.78L.675 0 0 .672l3.853 3.832-3.85 3.83.637.633 3.937-3.743L8.373 9 9 8.377 5.165 4.466z"
            fill="currentcolor"
            fillRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
}

CartListItem.propTypes = {
  deviceType: PropTypes.string,
  item: PropTypes.object,
  galleryPricings: PropTypes.object,
  onItemPurchaseAttributesChanged: PropTypes.func,
  onRemoveItem: PropTypes.func,
  site: PropTypes.any,
  t: PropTypes.any
};
